import { QuestionnaireMeta } from 'features/generalQuestionnaire/model';

import { BaseQuestionnaire } from '../models';

export const useGetInitialAnswers = (
  questionnaireMeta: QuestionnaireMeta,
  policyQuestionnaire: BaseQuestionnaire
): Record<string, unknown> => {
  const initialAnswers = {
    ...(policyQuestionnaire?.answers?.personalInfo || {}),
    ...(policyQuestionnaire?.answers?.tariffInfo || {}),
  };

  const questionListNames = questionnaireMeta.questionList.map(
    ({ name }) => name
  );

  return Object.fromEntries(
    Object.entries(initialAnswers).filter(([key]) =>
      questionListNames.includes(key)
    )
  );
};
